import ProductProvider from '@/resources/product_provider'
const productProvider = new ProductProvider()

const state = {
  products: [],
  searchKey: '',
  productsNumber: 0,
  isLoading: false
}

const actions = {
  initState ({commit}) {
    commit('INIT_STATE')
  },
  async setSearchKey ({commit}, payload) {
    const data = await productProvider.getProduct(payload)
    if (data.productsNumber) {
      commit('SET_SEARCH_KEY', payload)
      commit('SET_PRODUCTS', data)
      return true
    } else {
      commit('INIT_STATE')
      return false
    }
  },
  async loadProductMore ({commit, state}, page) {
    const data = await productProvider.getProduct(state.searchKey, page)
    commit('ADD_PRODUCTS', data)
  },
  setIsloading ({ commit }, payload) {
    commit('SET_IS_LOADING', payload)
  }
}

const mutations = {
  INIT_STATE: (state) => {
    state.products = []
    state.searchKey = ''
    state.productsNumber = 0
    state.isLoading = false
  },
  SET_PRODUCTS: (state, payload) => {
    state.productsNumber = payload.productsNumber
    if (payload.products) {
      state.products = payload.products
    }
  },
  ADD_PRODUCTS: (state, payload) => {
    state.productsNumber += payload.productsNumber
    if (payload.products) {
      state.products.push(...payload.products)
    }
  },
  SET_SEARCH_KEY: (state, payload) => {
    state.searchKey = payload
  },
  SET_IS_LOADING: (state, payload) => {
    state.isLoading = payload
  }
}

const getters = {
  getProduct: (state) => {
    return state.products
  },
  getSearchKey: (state) => {
    return state.searchKey
  },
  productsNumber: (state) => {
    return state.productsNumber
  },
  getIsLoading: (state) => {
    return state.isLoading
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js